<template>
	<div class="video-loop">
		<video :key="id" ref="loop" :autoplay="autoplay" loop muted playsinline>
			<source :src="sourceVideo" :type="type" />
			Sorry, your browser doesn't support embedded videos.
		</video>
		<button
			v-if="displayControls"
			class="video-loop__pause-button"
			:aria-label="isPlaying ? 'Stop Video' : 'Play Video'"
			:aria-live="isInView ? 'off' : 'polite'"
			@click="pauseLoop"
		>
			<svg
				v-if="isPlaying"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 40 40"
			>
				<path d="M24.75 39V1h11.88v38zM3.37 39V1h11.88v38z" fill="#fff" />
			</svg>
			<svg
				v-if="!isPlaying"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 40 40"
			>
				<path
					d="M6.3 39a1.46 1.46 0
				0 1-1.46-1.46V2.46a1.46 1.46 0 0 1 2.25-1.23l27.4 17.54a1.46
				1.46 0 0 1 0 2.46L7.09 38.77a1.47 1.47 0 0 1-.79.23z"
					fill="#fff"
				/>
			</svg>
		</button>
	</div>
</template>

<script>
import { EventBus } from '../../utils/EventBus';

export default {
	props: {
		autoStart: { type: Boolean, required: false, default: true },
		displayControls: { type: Boolean, default: true },
		source: { type: String, required: true },
		sourceMobile: { type: String, required: false, default: '' },
		type: { type: String, required: true },
	},

	data() {
		return {
			autoplay: this.autoStart,
			videoSource: this.source,
			videoType: null,
			id: this.$_getUid(),
			isInView: false,
			isPlaying: this.autoStart,
			observer: null,
			sourceVideo: '',
		};
	},

	computed: {
		hasAnimation() {
			return this.$store.state.hasAnimation;
		},
		media() {
			return this.$store.state.WindowWidth.name;
		},
	},

	watch: {
		isInView() {
			const method = this.isPlaying ? 'play' : 'pause';
			this.$refs.loop[method]();
		},
		media() {
			this.switchSource();
		},
		hasAnimation() {
			this.pauseLoop();
		},
	},

	mounted() {
		if (this.autoStart) {
			this.observer = new IntersectionObserver((entries) => {
				const video = entries[0];
				if (video.isIntersecting) {
					this.isPlaying = true;
					this.isInView = true;
				} else {
					this.isPlaying = false;
					this.isInView = false;
				}
			});
			this.observer.observe(this.$el);
		} else {
			this.observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (
							Math.trunc(entry.intersectionRatio) === 1 &&
							this.hasAnimation
						) {
							this.isPlaying = true;
							this.isInView = true;
						} else if (
							Math.trunc(entry.intersectionRatio) === 0 &&
							this.hasAnimation
						) {
							this.isPlaying = false;
							this.isInView = false;
						}
					});
				},
				{
					threshold: [0, 1.0],
				}
			);
			this.observer.observe(this.$el);
		}
		this.switchSource();
	},
	created() {
		EventBus.$on('open-modal', () => {
			this.isPlaying ? this.pauseLoop() : null;
		});
		EventBus.$on('close-modal', () => {
			this.autoStart ? this.pauseLoop() : null;
		});
	},
	methods: {
		pauseLoop() {
			const method = this.isPlaying ? 'pause' : 'play';
			this.$refs.loop[method]();
			this.isPlaying = !this.isPlaying;
			document.activeElement.blur();
		},
		switchSource() {
			if (this.media === 'mobile' && this.sourceMobile) {
				this.sourceVideo = this.sourceMobile;
			} else {
				this.sourceVideo = this.source;
			}
			this.id = this.$_getUid();
		},
	},
};
</script>
